export default "__VITE_ASSET__BEdHrI$p__"